// extracted by mini-css-extract-plugin
module.exports = {"home":"HorizonteHome_home__Qbfwp"};